import * as React from 'react';
import { UIHeading4, UIText1 } from '@cian/ui-kit';
import * as styles from './HeaderMobile.css';
import { TReliabilityType } from '../../../types/developerV2/reliability';
import { clsx } from 'clsx';
import { statusToTheme } from '../utils';

interface IHeaderProps {
  title: string;
  description?: string | null;
  status: TReliabilityType;
}

export const HeaderMobile = (props: IHeaderProps) => {
  return (
    <div className={styles['header']}>
      <div className={clsx(styles['title'], styles[statusToTheme(props.status)])}>
        <div className={styles['logo']} />
        <UIHeading4>{props.title}</UIHeading4>
      </div>
      <div className={styles['description']}>
        <UIText1>{props.description}</UIText1>
      </div>
    </div>
  );
};
